import { render, staticRenderFns } from "./ThkMaterialTabs.vue?vue&type=template&id=97c95c74&scoped=true"
import script from "./ThkMaterialTabs.vue?vue&type=script&lang=js"
export * from "./ThkMaterialTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c95c74",
  null
  
)

export default component.exports